/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { GetFederalTaxPaymentResponseDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchFederalTaxPaymentsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags FederalTaxPayment
   * @name FederalTaxPaymentGet
   * @summary Returns ach federal tax payment information
   * @request GET:/achFederalTaxPayments/{achPaymentUniqueId}
   */
  federalTaxPaymentGet = (
    achPaymentUniqueId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<GetFederalTaxPaymentResponseDto, any>({
      path: `/achFederalTaxPayments/${achPaymentUniqueId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
